function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Lander-step-count-1");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-white",
  d: "M11.5,259.71a10,10,0,0,1-10-10v-7.09a10,10,0,0,1,7.78-9.75l10.79-2.44c.05-4.28.08-8.44.08-12.43V178.84l-3.92.35c-.3,0-.61,0-.91,0a10,10,0,0,1-10-10V160.4a10,10,0,0,1,7.83-9.76l37.91-8.4a9.86,9.86,0,0,1,2.16-.24,10,10,0,0,1,5.81,1.86l2.13,1.52a10,10,0,0,1,4.18,8.42l-.6,21.54V218c0,4,0,8.16.07,12.46l10.1,2.45a10,10,0,0,1,7.63,9.71v7.09a10,10,0,0,1-10,10Z",
  transform: "translate(0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-primary",
  d: "M72.57,242.63v7.09H11.5v-7.09L31,238.2H54.32ZM53.24,152l2.13,1.53-.61,21.68V218c0,10.33.16,21.15.46,31.71H29.69c.31-10.56.46-21.38.46-31.71V167.9l-14.82,1.34V160.4Z",
  transform: "translate(0)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-none",
  width: 260,
  height: 260
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-white",
  x: 5,
  y: 170,
  width: 16,
  height: 64
});

var SvgStepCount1 = function SvgStepCount1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 260 260",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStepCount1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step-count-1.b768dd25.svg";
export { ForwardRef as ReactComponent };